import { Link } from "@tvg/fuse/link";
import classNames from "classnames";
import React from "react";
import styles from "./MenuSubDepartmentLink.module.css";

export interface MenuSubDepartmentLinkProps {
  href: string;
  spanNumber: number | null | undefined;
  spanText: React.ReactNode;
  className?: string;
  dataTestId?: string;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) => void;
}

const MenuSubDepartmentLink: React.FC<MenuSubDepartmentLinkProps> = ({
  href,
  spanNumber,
  spanText,
  className,
  dataTestId,
  onClick,
}) => (
  <>
    <Link
      className={classNames(
        styles.menuSubDepartmentLink,
        "slide-out-menu__department-link",
        className,
      )}
      dataTestId={dataTestId}
      href={href}
      onClick={onClick}
      size="large"
      underline={false}
    >
      <span
        className={`${styles.menuSubDepartmentLink__spanText} department-link__span-text`}
      >
        {spanText}
      </span>
      <span
        className={`${styles.menuSubDepartmentLink__spanNumber} department-link__span-number`}
      >
        {typeof spanNumber === "number" && spanNumber >= 10000
          ? "10k+"
          : spanNumber}
      </span>
    </Link>
  </>
);

export default MenuSubDepartmentLink;
